import { render } from "./PageSinavYorumlari.vue?vue&type=template&id=dbbf6212&scoped=true"
import script from "./PageSinavYorumlari.vue?vue&type=script&lang=js"
export * from "./PageSinavYorumlari.vue?vue&type=script&lang=js"

import "./PageSinavYorumlari.vue?vue&type=style&index=0&id=dbbf6212&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dbbf6212"

export default script